import debounce from 'lodash.debounce';

const noop = () => null;

const groupBy = <T, K extends string | number>(array: T[], fn: (item: T) => K): Record<K, T[]> =>
  array.reduce(
    (acc, item) => {
      const key = fn(item);
      const group = acc[key] || [];
      acc[key] = [...group, item];
      return acc;
    },
    {} as Record<K, T[]>,
  );

export { noop, groupBy, debounce };
